import React, {Component} from 'react';
import {ContentMap} from '../config/contentMap';
import store from '../../store';
import { disableLanguageSelectorToggle } from '../../actions/commonActions';
import { setLocaleWithFallback } from '../../actions/index';
import { preferredLanguageName } from '../../i18n/config';

// i18n
import { Translate } from 'react-redux-i18n';
import './formUnavailablePage.css';

class FormUnavailable extends Component{

    state = {
        errorId : 2
    }

    componentDidMount(){
        //console.log(this.props.searchData);
        if(Boolean(this.props.searchData.data))
        {
            if(Boolean(this.props.searchData.data.preferredLanguage)){this.setLang(this.props.searchData.data.preferredLanguage);}
        }
        
        if(this.props.searchData.errorCode === "41004")
        {   
            if(Boolean(this.props.searchData.data)){
                if(this.props.app && this.props.app == 'renewal' && this.props.searchData.data.contactType === "Other"){
                    this.setState({errorId:2});
                }
                else if(this.props.app && this.props.app == 'renewal') {
                    this.setState({errorId:4});
                } else {
                    this.setState({errorId:3});
                }
            }
            else{
                if(this.props.app && this.props.app == 'renewal') {
                    this.setState({errorId:4});
                } else {
                    this.setState({errorId:3});
                }
            }
        }
        else if(this.props.searchData.isPartnerContact && this.props.searchData.programType !== "APC")
        {
            this.setState({errorId:0});
        }
        else if(!this.props.searchData.isPartnerContact)
        {
            this.setState({errorId:1});
        }
        else
        {
            this.setState({errorId:2});
        }
    }

    setLang = (lang) => {
        const finalLocale = Object.keys(preferredLanguageName).includes(lang)
                    ? preferredLanguageName[lang] : 'en_US';
            store.dispatch(setLocaleWithFallback(finalLocale));
            store.dispatch(disableLanguageSelectorToggle(true));
    }

    render(){
        
        var TAG = ContentMap['unavailable'][this.state.errorId];
     
        return (<div>
            
            <TAG {...this.props} />
        </div>);
    }
}


  
export default FormUnavailable;